<template>
  <div class="paynext">
       <Step class="step" :active="active_index" thirdText="购买成功" ></Step>
       <PayStatusBar :status="Number(status)" type="0"></PayStatusBar>
        <!-- <PurchaseTitle titlename="购券信息"></PurchaseTitle> -->
        <!-- <CouponDetail :couponInfo="couponDetail"></CouponDetail> -->

  </div>
</template>
<script>
import {mapState} from 'vuex'
import Step from './components/step.vue'
import PurchaseTitle from './components/title.vue'
import CouponDetail from './components/CouponDetail.vue'
import PayStatusBar from './components/PayStatusBar.vue'

export default {
  name: 'payNext',
  data () {
    return {
      active_index: 2,
      status: this.$route.query.status,
      couponDetail: this.$store.state.couponPay.couponInfo
    }
  },
  components: {Step, PurchaseTitle, CouponDetail, PayStatusBar},
  computed: {
    ...mapState('couponPay', ['couponInfo'])
  },
  mounted () {
    document.getElementsByClassName('app-router-wrap')[0].scrollTop = 0
  },
  watch: {
    couponInfo: function (value) {
      console.log('ssss')
      if (value) {
        this.couponDetail = value
      }
    }
  }

}
</script>
<style  scoped lang="stylus">
    .paynext{
        padding-left:20px;
        margin-bottom: 50px;
        .step{
            margin-left:20px;
        }
    }
</style>
